// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__u6v4J","middleBtn":"style_middleBtn__3oDCg","leftBtn":"style_leftBtn__3EHVW","rightBtn":"style_rightBtn__C2gWx"};